
import { DefaultState, Filters } from 'store/types';

export const LODGING_REQUEST_EXPORT_EXCEL_REQUEST = 'LODGING_REQUEST_EXPORT_EXCEL_REQUEST';
export const LODGING_REQUEST_EXPORT_EXCEL_SUCCESS = 'LODGING_REQUEST_EXPORT_EXCEL_SUCCESS';
export const LODGING_REQUEST_EXPORT_EXCEL_FAILURE = 'LODGING_REQUEST_EXPORT_EXCEL_FAILURE';

export interface LodgingRequestExportExcelParams {
  filters: Filters;
  columns: string[];
  rowsCount: number;
};

export type LodgingRequestExportExcelState = DefaultState & {
  contents?: {};
};

interface LodgingRequestExportExcelRequest {
  type: typeof LODGING_REQUEST_EXPORT_EXCEL_REQUEST;
};

interface LodgingRequestExportExcelSuccess {
  type: typeof LODGING_REQUEST_EXPORT_EXCEL_SUCCESS,
  contents: {};
}

interface LodgingRequestExportExcelFailure {
  type: typeof LODGING_REQUEST_EXPORT_EXCEL_FAILURE;
}

export type LodgingRequestExportExcelActionTypes = LodgingRequestExportExcelRequest | LodgingRequestExportExcelSuccess | LodgingRequestExportExcelFailure;